<template>
  <div class="d-flex flex-column align-center justify-center text-center h-100 w-100 py-6 px-4">
    <v-card color="primary" flat class="pa-3 mb-6">
      <v-img height="48" width="48" :src="brandIconWhite" />
    </v-card>
    <div class="text-h5 mb-3">This scheduling link isn't working</div>
    <div class="text-body-1 grey--text text--darken-1" style="max-width: 480px">
      The link you followed is incomplete or no longer exists. Double-check the
      URL, or ask the person who sent it to share a new scheduling link.
    </div>
  </div>
</template>

<script>
import brandIconWhite from '@/assets/img/brand/Symbo_Icon_White.svg'

export default {
  name: 'NotFoundView',
  data: () => ({
    brandIconWhite,
  }),
  mounted() {
    document.title = 'Symbo Scheduler'
  },
}
</script>
